<template>
  <el-row v-loading="loading">
 <el-row class="padding_5px_top">
      <el-tabs
        id="rankingTab"
        v-model="activeName"
      >

        <el-tab-pane name="first">
          <span slot="label">股票型2 <i class="el-icon-arrow-down"></i></span>
          <el-tabs
            id="EqutityTab"
            v-model="activeNameEqutity"
          >
            <el-tab-pane
              label="普通股票型"
              name="first"
            ></el-tab-pane>
            <!-- <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="行业股票 - 其它"
              name="CHCA000047"
            ></el-tab-pane>    -->
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane name="second">
          <span slot="label">混合型 <i class="el-icon-arrow-down"></i></span>
          <el-tabs
            id="AllocationTab"
            v-model="activeNameAllocation"
          >
            <el-tab-pane
              label="积极配置型"
              name="first"
            ></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="标准混合型"
              name="second"
            ></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="保守混合型"
              name="third"
            ></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="灵活配置型"
              name="fourth"
            ></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="行业混合-科技、传媒及通讯"
              name="fifth"
            ></el-tab-pane>   
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="沪港深积极配置型"
              name="sixth"
            ></el-tab-pane>      
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="沪港深保守混合型"
              name="seventh"
            ></el-tab-pane>   
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="沪港深灵活配置型"
              name="eighth"
            ></el-tab-pane>            
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="目标日期"
              name="ninth"
            ></el-tab-pane>                              
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane name="third">
          <span slot="label">债券型 <i class="el-icon-arrow-down"></i></span>
          <el-tabs
            id="BondTab"
            v-model="activeNameBond"
          >
            <el-tab-pane
              label="积极债券型"
              name="first"
            ></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="普通债券型"
              name="second"
            ></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="纯债型"
              name="third"
            ></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="利率债"
              name="CHCA000048"
            ></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="信用债"
              name="CHCA000049"
            ></el-tab-pane>  
            <el-tab-pane label="|"></el-tab-pane>
            <el-tab-pane
              label="短债型"
              name="fourth"
            ></el-tab-pane>
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane name="fourth">
          <span slot="label">另类 <i class="el-icon-arrow-down"></i></span>
          <el-tabs
            id="MarketNeutralTab"
            v-model="activeNameMarketNeutral"
          >
            <el-tab-pane
              label="市场中性"
              name="first"
            ></el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane name="fifth">
          <span slot="label">其它 <i class="el-icon-arrow-down"></i></span>
          <el-tabs
            id="OthersTab"
            v-model="activeNameOthers"
          >
            <el-tab-pane
              label="其它"
              name="first"
            ></el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>

    </el-row>

    <div class="line"></div>

    <el-table
      :data="tableData"
      border
      @sort-change="sortChange"
      :default-sort="{ prop: 'PriceDate', order: 'descending' }"
      style="width: 100%;"
      class="tableSpecial"
    >

      <el-table-column
        fixed
        sortable="custom"
        prop="defaultSymbol"
        label="基金代码"
        width="110"
      >
      </el-table-column>
      <el-table-column
        fixed
        sortable="custom"
        prop="legalName"
        label="基金名称"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="inceptionDate"
        label="成立日期"
        min-width="120"
        sortable="custom"
      >
        <template slot-scope="scope">{{ scope.row.inceptionDate | replaceTime }}</template>
      </el-table-column>
      <el-table-column
        prop="priceDate"
        label="最新净值|日期"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">{{ scope.row.priceDate | replaceTime }}</template>
      </el-table-column>
      <el-table-column
        prop="nav"
        label="单位净值|(元)"
        min-width="120"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.nav | fillNullRound4 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="return1Day"
        label="日回报|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Day | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Day)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="returnYTD"
        label="今年以来|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.returnYTD | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnYTD)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="return1Week"
        label="最近一周|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Week | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Week)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="return1Month"
        label="最近一月|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Month)">%</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="return3Month"
        label="最近三月|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return3Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Month)">%</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="return6Month"
        label="最近六月|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return6Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return6Month)">%</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="return1Year"
        label="最近一年|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Year)">%</span>
        </template>
      </el-table-column>

      <el-table-column
        label="最近两年"
        align="center"
      >
        <el-table-column
          prop="return2Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return2Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn2Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn2Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近三年"
        align="center"
      >
        <el-table-column
          prop="return3Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn3Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn3Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近五年"
        align="center"
      >
        <el-table-column
          prop="return5Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return5Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn5Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn5Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近七年"
        align="center"
      >
        <el-table-column
          prop="return7Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return7Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn7Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn7Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近十年"
        align="center"
      >
        <el-table-column
          prop="return10Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return10Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn10Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn10Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近十五年"
        align="center"
      >
        <el-table-column
          prop="return15Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return15Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn15Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn15Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="returnInception"
        label="成立以来|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.returnInception | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnInception)">%</span>
        </template>
      </el-table-column>
    </el-table>
    <el-col class="left_text_align padding_25px_top">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count > 10 ? true : false"
      >
      </el-pagination>
    </el-col>
  </el-row>
</template>
<script>
import starrating0 from "../../public/images/smallstar0.gif";
import starrating1 from "../../public/images/smallstar1.gif";
import starrating2 from "../../public/images/smallstar2.gif";
import starrating3 from "../../public/images/smallstar3.gif";
import starrating4 from "../../public/images/smallstar4.gif";
import starrating5 from "../../public/images/smallstar5.gif";

import { Message } from "element-ui";
import { getFundRank } from "../api/ranking";
import { loadingData } from "./mixin/loadingData";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const removeNameAndValue=componentsCommon.localStorage.removeNameAndValue;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;
const formatDecimal=componentsCommon.apiCommon.formatDecimal;
const dateWithForwardSlash=componentsCommon.apiCommon.dateWithForwardSlash;

export default {
    mixins: [loadingData],
    data() {
        return {
            activeName: "first",
            activeNameEqutity: "first",
            activeNameAllocation: "first",
            activeNameBond: "first",
            activeNameMarketNeutral: "first",
            activeNameOthers: "first",
            dialogLoading: false,
            loading: false,
            tableData: [],
            pageSize: 0,
            selectFormat: "xlsx",
            pagination: {
                skip: 0,
                limit: 10,
                count: 0,
            },
            params: {
                type: "CloseEnd",
                category: "", //"EquityFunds",
                keyword: "",
                date: "", //"2020-06-30",
                month: "", //"2020-06-30",
                quarter: "", //"2020-06-30",
                sort: "PriceDate",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1,
            },
        };
    },
    watch: {
        activeName: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "EquityFunds",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "second":
                    self.loadingData(
                        "AggressiveAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "third":
                    self.loadingData(
                        "AggressiveBondFund",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "fourth":
                    self.loadingData(
                        "MarketNeutral",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "fifth":
                    self.loadingData(
                        "Others",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
            }
            self.resetPaginationParameter();
        },
        activeNameEqutity: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "EquityFunds",
                        self.params.keyword,
                        self.params.date
                    );
                    break;     
                case "CHCA000047":
                    self.loadingData(
                        "SectorEquityOther",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;                                
            }
            self.resetPaginationParameter();
        },
        activeNameAllocation: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "AggressiveAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "second":
                    self.loadingData(
                        "ModerateAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "third":
                    self.loadingData(
                        "ConservativeAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "fourth":
                    self.loadingData(
                        "FlexibleAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "fifth":
                    self.loadingData(
                        "SectorAllocationTechnologyAndCommunications",
                        self.params.keyword,
                        self.params.date
                    );
                    break;                       
                case "sixth":
                      self.loadingData(
                          "ShanghaiHongKongShenzhenAggressiveAllocation",
                          self.params.keyword,
                          self.params.date
                      );
                      break;   
                  case "seventh":
                      self.loadingData(
                          "ShanghaiHongKongShenzhenConservativeAllocation",
                          self.params.keyword,
                          self.params.date
                      );
                      break;      
                  case "eighth":
                      self.loadingData(
                          "ShanghaiHongKongShenzhenFlexibleAllocation",
                          self.params.keyword,
                          self.params.date
                      );
                      break;   
                  case "ninth":
                      self.loadingData(
                          "TargetDate",
                          self.params.keyword,
                          self.params.date
                      );
                      break;                                       
            }
            self.resetPaginationParameter();
        },
        activeNameBond: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "AggressiveBondFund",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "second":
                    self.loadingData(
                        "NormalBondFund",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "third":
                    self.loadingData(
                        "PureBond",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "fourth":
                    self.loadingData(
                        "ShortTermBondFund",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "CHCA000048":
                    self.loadingData(
                        "GovernmentAndPolicyBankBond",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "CHCA000049":
                    self.loadingData(
                        "CorporateBond",
                        self.params.keyword,
                        self.params.date
                    );
                    break;                    
            }
            self.resetPaginationParameter();
        },
        activeNameMarketNeutral: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "MarketNeutral",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
            }
            self.resetPaginationParameter();
        },
        activeNameOthers: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "Others",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
            }
            self.resetPaginationParameter();
        },
    },
    filters: {
        fillNull(value) {
            if (value != undefined && value != null && value != "") {
                return value;
            } else {
                return "--";
            }
        },
        fillNullRound(value, fixedDecimal) {
            if (value != undefined && value != null && value != "") {
                return formatDecimal(value, fixedDecimal);
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return dateWithForwardSlash(value);
            } else {
                return "--";
            }
        },
    },
    mounted() {
        /*const self = this;
        self.getData(self.params);*/
    },
    methods: {
        showUnidentifiedData() {
            let unidentifiedList = getNameAndValue("unidentifiedList");
            unidentifiedList = JSON.parse(unidentifiedList);
            const blob = new Blob(["\ufeff" + unidentifiedList.join("\n")], {
                type: "text/csv;charset=utf-8",
            });
            createLinkForDownload(blob, "unidentifiedList.csv");
        },
        loadingData(category, keyword, effectiveDate) {
            const self = this;
            self.params.category = category;
            if (category != null && category != "") {
                self.params.category = category;

                switch (category) {
                    case "EquityFunds":
                        self.activeName = "first";
                        self.activeNameEqutity = "first";
                        break;
                    case "AggressiveAllocationFund":
                        self.activeName = "second";
                        self.activeNameAllocation = "first";
                        break;
                    case "AggressiveBondFund":
                        self.activeName = "third";
                        self.activeNameBond = "first";
                        break;
                    case "MarketNeutral":
                        self.activeName = "fourth";
                        self.activeNameMarketNeutral = "first";
                        break;
                    case "Others":
                        self.activeName = "fifth";
                        self.activeNameOthers = "first";
                        break;
                }
            }

            if (keyword != null && keyword != "") {
                self.params.keyword = keyword;
            } else {
                self.params.keyword = "";
            }

            if (effectiveDate != null && effectiveDate != "") {
                self.params.date = effectiveDate;
            } else {
                self.params.date = "";
            }
            /*self.params.month=effectiveDate;
            self.params.quarter=effectiveDate;*/
            self.getData(self.params);
        },
    },
};
</script>
<style lang="scss">
@import "../../public/sass/components/ranking";
</style>
<style scoped>
/*给table了列添加左边的border begin*/
.tableSpecial >>> table tr:nth-child(1) {
    line-height: 35px;
}

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(2),
.tableSpecial >>> table tr td:nth-last-child(1),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(3),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(3),
.tableSpecial >>> table tr td:nth-last-child(3),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(4),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(5),
.tableSpecial >>> table tr td:nth-last-child(5),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(5),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(7),
.tableSpecial >>> table tr td:nth-last-child(7),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(6),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(9),
.tableSpecial >>> table tr td:nth-last-child(9),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(7),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(11),
.tableSpecial >>> table tr td:nth-last-child(11),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(8),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(13),
.tableSpecial >>> table tr td:nth-last-child(13),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(9),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(14),
.tableSpecial >>> table tr td:nth-last-child(14),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(10),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(15),
.tableSpecial >>> table tr td:nth-last-child(15),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(11),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(16),
.tableSpecial >>> table tr td:nth-last-child(16),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(12),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(17),
.tableSpecial >>> table tr td:nth-last-child(17),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(13),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(18),
.tableSpecial >>> table tr td:nth-last-child(18),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(14),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(19),
.tableSpecial >>> table tr td:nth-last-child(19),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(17),
.tableSpecial >>> table tr td:nth-last-child(22) {
    border-left: 1px solid #ebeef5 !important;
}
/*给table了列添加左边的border end*/
</style>
